/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { DeveloperService } from '../services/developer.service';

const developerState = {
};

const mutations = {
};

const getters = {
};

const actions = {
  logs: async ({}, params) => {
    try {
      const logs = await DeveloperService.getLogs(params);
      return logs;
    } catch (e) {
      return false;
    }
  },

  log: async ({}, id) => {
    try {
      const log = await DeveloperService.getLog(id);
      return log;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  state: developerState,
  mutations,
  getters,
  actions,
};
